export default __webpack_public_path__ + "static/media/GalanoGrotesque-Medium.f41052d0.ttf";